<template>
    <ur-modal ref="modal" class="wrongPageMessageModal" noFoot @close="close()">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="180" height="120.03" viewBox="0 0 180 120.03">
                <g id="illust_no_connection" transform="translate(0 .03)">
                    <path id="path_144056" data-name="path 144056" style="fill:none" d="M0 0h180v120H0z"/>
                    <g id="g_10" data-name="g 10" transform="translate(18.453 -.746)">
                        <path id="path_205265" data-name="path 205265" class="cls-2" d="M122.647 69.547a50.756 50.756 0 0 1-15.1 36.2 50.1 50.1 0 0 1-35.6 14.6 50.8 50.8 0 1 1 50.7-50.8z"/>
                        <path id="path_205266" data-name="path 205266" class="cls-2" d="M118.247 36.246a4.1 4.1 0 1 0-4.1-4.1 4.1 4.1 0 0 0 4.1 4.1z"/>
                        <path id="path_205267" data-name="path 205267" class="cls-2" d="M124.247 20.247a2.8 2.8 0 1 0-2.8-2.8 2.8 2.8 0 0 0 2.8 2.8z"/>
                        <path id="path_205268" data-name="path 205268" class="cls-2" d="M22.847 36.146a2.8 2.8 0 1 0-2.8-2.8 2.8 2.8 0 0 0 2.8 2.8z"/>
                        <path id="path_205269" data-name="path 205269" class="cls-2" d="M5.747 90.147a5.2 5.2 0 1 0-5.2-5.2 5.2 5.2 0 0 0 5.2 5.2z"/>
                        <g id="g_120211" data-name="g 120211">
                            <path id="path_205270" data-name="path 205270" d="m108.076 46.257.8 64.4a3.927 3.927 0 0 1-4 3.9h-62.8a3.992 3.992 0 0 1-4-3.9v-82.8a3.927 3.927 0 0 1 4-3.9h45.5z" style="fill:#fff"/>
                        </g>
                        <path id="path_205271" data-name="path 205271" class="cls-4" d="M70.776 37.457h-22.1a1.3 1.3 0 1 1 0-2.6h22.1a1.3 1.3 0 1 1 0 2.6z"/>
                        <path id="path_205272" data-name="path 205272" class="cls-4" d="M60.276 44.658h-11.6a1.3 1.3 0 1 1 0-2.6h11.5a1.324 1.324 0 0 1 1.3 1.3 1.309 1.309 0 0 1-1.2 1.3z"/>
                        <path id="path_205273" data-name="path 205273" class="cls-4" d="M87.576 23.958v17.8a4.655 4.655 0 0 0 4.7 4.5h15.8"/>
                        <path id="path_205274" data-name="path 205274" class="cls-2" d="m57.309 37.223 4.752-16.76 19.517 2.248-6.814 10.922 5.278 4.217L68.679 62.7l.633-19.242z"/>
                        <path id="path_205275" data-name="path 205275" class="cls-5" d="m61.527 18.012-3.782-5.692"/>
                        <path id="path_205276" data-name="path 205276" class="cls-5" d="M71.612 15.166 72.056.747"/>
                        <path id="path_205277" data-name="path 205277" class="cls-5" d="m80.654 18.147 6.037-13.1"/>
                        <path id="path_205278" data-name="path 205278" class="cls-6" d="M60.114 90.126a1.762 1.762 0 0 1-1.089-.42 1.576 1.576 0 0 1 0-2.184 20.593 20.593 0 0 1 28.819 0 1.542 1.542 0 0 1-2.178 2.184 17.36 17.36 0 0 0-24.463 0 1.762 1.762 0 0 1-1.089.42z" transform="translate(0 -2)"/>
                        <path id="path_205279" data-name="path 205279" class="cls-6" d="m65.411 67.61 2.016-2.016a1.545 1.545 0 0 0-2.184-2.184l-2.016 2.016-2.017-2.016a1.545 1.545 0 0 0-2.184 2.184l2.016 2.016-2.016 2.016a1.573 1.573 0 0 0 0 2.184 1.391 1.391 0 0 0 1.092.42 1.769 1.769 0 0 0 1.092-.42l2.016-2.016 2.016 2.016a1.391 1.391 0 0 0 1.092.42 1.769 1.769 0 0 0 1.092-.42 1.573 1.573 0 0 0 0-2.184z"/>
                        <path id="path_205280" data-name="path 205280" class="cls-6" d="m85.826 67.61 2.016-2.016a1.545 1.545 0 0 0-2.184-2.184l-2.016 2.016-2.017-2.016a1.545 1.545 0 1 0-2.184 2.184l2.016 2.016-2.016 2.016a1.573 1.573 0 0 0 0 2.184 1.391 1.391 0 0 0 1.092.42 1.769 1.769 0 0 0 1.092-.42l2.016-2.016 2.016 2.016a1.391 1.391 0 0 0 1.092.42 1.769 1.769 0 0 0 1.092-.42 1.573 1.573 0 0 0 0-2.184z"/>
                    </g>
                </g>
            </svg>
        </div>

        <div style="margin-top:24px">
            <strong>요청하신 페이지를 찾을 수 없습니다.</strong><br>
            잘못된 링크를 사용하셨거나, 페이지가 존재하지 않습니다.<br>
            홈으로 이동해주시기 바랍니다.
        </div>
        <div style="margin-top:32px">
            <ur-button large text="홈으로 이동하기" solid primary @click="close()" style="width:208px"/>
        </div>
    </ur-modal>
</template>
<script>
export default {
    name: 'WrongPageMessageBox',
    data() {
        return {
        }
    },
    methods:{
        open(){
            this.$refs['modal'].open();
        },
        close(){
            utils.goHome();
            this.$refs['modal'].close();
        },
    },
}
</script>
<style scoped>
    div {
        text-align: center;
        font-size: 24px;
        line-height: 1.5;
        color: #333;
    }
    div strong {
        font-size: 24px;
        font-weight: bold;
    }
    .cls-2{
        fill:#eaeef9
    }
    .cls-4{
        fill:#d5ddea
    }
    .cls-5{
        fill:none;
        stroke:#a2abbe;
        stroke-width:2px;
    }
    .cls-6{
        fill:#989fb0
    }
</style>
<!--
<style>
    .wrongPageMessageModal .ur-modal__container--wrapper .ur-modal__container {
        padding: 48px 32px;
    }
    .wrongPageMessageModal .ur-modal__container--wrapper .ur-modal__container .ur-modal__close.ur-icon.ur-icon--line.opus-icon__close {
        display: none;
    }
    .wrongPageMessageModal .ur-modal__container--wrapper .ur-modal__container .ur-modal__body {
        margin-top: 0px;
    }
</style>
-->